/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - European Union 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [home-space.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 06.10.18 15:48
 */

import React, {useEffect} from 'react';
import Timeline from "../components/billboard-timeline/timeline";
import Sidebar from '../components/billboard-sidebar/sidebar';
import HeadlinesHome from '../components/billboard-headlines/home/headlines-home';
import BillboardHomeCover from '../components/billboard-cover/home/billboard-home-cover';
import useAsyncFetchHomeData from "../components/hooks/async-fetch-home-data";
import {Redirect, useLocation, useParams} from "react-router-dom";
import {useDispatch} from "react-redux";
import {localResetGeneric} from "../actions/spaces";
import {isSideBarHidden, useIsMobile, useLanguage} from "../components/configuration/configuration";
import {PENDING_STATUS} from "../actions";
import {SpinnerBig} from "../components/util/spinner";
import {useAuthorization, useSiteConfiguration} from "../selectors";
import {notifyWarning} from "../components/notifications/notify";
import EventsSlider from "../components/events-slider/events-slider";

const HOME_SPACE = 'home';

// initial component for user home space
// TODO configuration is missing as parameter for Timeline
const HomeSpace = () => {
    const {username} = useParams();
    const location = useLocation();
    const {homedata, status} = useAsyncFetchHomeData();
    const {isAuthorized, isSuperUser, principalUsername} = useAuthorization();
    const {isSitePublicPage} = useSiteConfiguration();
    const isMobile = useIsMobile();
    const dispatch = useDispatch();
    const Lang = useLanguage();

    // force a reloading of generic spaces on a username change by setting the store to null
    // see async-fetch-generic-spaces.js
    useEffect(()=> {
        dispatch(localResetGeneric());
    }, [username]);


    // return empty container to prevent flickering
    if (status === PENDING_STATUS || !homedata) return <div className='home-space-container'>
        <SpinnerBig className='mt-5'/>
    </div>

    // page of superuser is allowed in public mode
    if(!isAuthorized && !isSitePublicPage) {
        notifyWarning(Lang.access.mustLogin.text);
        return <Redirect to='/login'/>
    }

    return <div className='home-space-container'>
        <div className='row'>
            <div className='col-sm-9'>
                <BillboardHomeCover username={username} location={location}/>
                <EventsSlider/>

                <div className='row mt-2 pl-1'>
                    <div className='col-sm-5'>
                        <HeadlinesHome username={username} spaceId={HOME_SPACE}/>
                    </div>

                    <div className='col-sm-7'>
                        <Timeline spacename={HOME_SPACE}
                                  spaceId={HOME_SPACE}
                                  username={username}/>
                    </div>
                </div>

            </div>
            <div className='col-sm-3'>
                {!isMobile && !isSideBarHidden() && <Sidebar username={username} location={location}/>}
            </div>
        </div>
    </div>
}

export default HomeSpace;